import api from "@/api/visary-api";
import CrudService from "./crud-service";

export default class SettingsCrudService extends CrudService {
  constructor(mnemonic) {
    super(mnemonic);
  }

  async get() {
    return await api.settings.get(this.mnemonic);
  }

  async save(patch) {
    return await api.settings.create(this.mnemonic, patch);
  }


}
